module.exports = __webpack_public_path__ + "img/pinterest-circle.e1f50651.png";